"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _DropdownItem = _interopRequireDefault(require("../DropdownItem"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _excluded = ["title", "href", "onClick", "variant", "class", "value", "image", "icon", "description", "disabled"];

var SingleItemList = function SingleItemList(_ref) {
  var item = _ref.item;
  var title = item.title,
      href = item.href,
      onClick = item.onClick,
      variant = item.variant,
      customClass = item.class,
      value = item.value,
      image = item.image,
      icon = item.icon,
      description = item.description,
      disabled = item.disabled,
      restProps = (0, _objectWithoutProperties2.default)(item, _excluded);
  return (0, _preact.h)(_DropdownItem.default, (0, _extends2.default)({}, restProps, {
    title: title,
    href: (0, _absoluteUrlRuntime.resolveUrl)(href),
    onClick: onClick ? function (e) {
      onClick(e);
    } : undefined,
    variant: variant,
    customClass: customClass,
    value: value,
    image: image,
    icon: icon ? (0, _preact.h)(_assets.default, {
      icon: icon
    }) : undefined,
    description: description,
    disabled: disabled
  }));
};

var _default = SingleItemList;
exports.default = _default;